import React from 'react';
import {Route,Redirect} from 'react-router-dom';

import authModel from '../../models/auth';

const PrivateRoute = ({component: Component,...rest})=>{
  const auth=authModel();
  return <Route {...rest}
    render={
      (props)=> auth.isLogged() ? <Component {...props} /> : <Redirect to="/" />
    }
  />

}

export default PrivateRoute;